module.exports = __webpack_public_path__ + "img/N774-1.8d6faaf6.png";